var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M2.66667 12.6667V11.3333H4V6.66667C4 5.74444 4.27778 4.92778 4.83333 4.21667C5.38889 3.49444 6.11111 3.02222 7 2.8V2.33333C7 2.05555 7.09445 1.82222 7.28333 1.63333C7.48333 1.43333 7.72222 1.33333 8 1.33333C8.27778 1.33333 8.51111 1.43333 8.7 1.63333C8.9 1.82222 9 2.05555 9 2.33333V2.8C9.88889 3.02222 10.6111 3.49444 11.1667 4.21667C11.7222 4.92778 12 5.74444 12 6.66667V11.3333H13.3333V12.6667H2.66667ZM8 14.6667C7.63333 14.6667 7.31667 14.5389 7.05 14.2833C6.79445 14.0167 6.66667 13.7 6.66667 13.3333H9.33333C9.33333 13.7 9.2 14.0167 8.93333 14.2833C8.67778 14.5389 8.36667 14.6667 8 14.6667ZM5.33333 11.3333H10.6667V6.66667C10.6667 5.93333 10.4056 5.30555 9.88333 4.78333C9.36111 4.26111 8.73333 4 8 4C7.26667 4 6.63889 4.26111 6.11667 4.78333C5.59444 5.30555 5.33333 5.93333 5.33333 6.66667V11.3333Z",
    fill: "#1D1B20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.28aeb12020859b60d8ca2a47b0834383.svg";
export { ForwardRef as ReactComponent };